import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User edited a context value',
  name: 'context_value_edited',
  params: [
    {
      description: 'The source of the edit',
      name: 'source',
      required: true,
      type: 'enum',
      values: ['manual'],
    },
    {
      description: 'The value type of the field',
      name: 'value_type',
      required: true,
      type: 'enum',
      values: ['text', 'file', 'color', 'font'],
    },
    {
      description: 'The name of the field',
      name: 'field_name',
      required: true,
      type: 'string',
    },
    {
      description: 'The type of edit performed',
      name: 'edit_type',
      required: true,
      type: 'enum',
      values: ['value', 'label', 'ai_instruction'],
    },
  ],
};

export default META;
